import React, { useState, useRef, useEffect } from 'react';
import { Form, Card, Button, Row, Col ,Table} from 'react-bootstrap';
import { BiUpload } from 'react-icons/bi';
import VendorAppBar from './VendorAppBar';
import { COLORS } from '../colors';
import axios from 'axios';
import '../EditableCard.css';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import api from '../../Services/api';
import { Satellite, Timer } from '@mui/icons-material';
import { FaFileDownload } from "react-icons/fa";
import { MdFileOpen, MdRemoveRedEye, MdDelete, MdEditDocument } from "react-icons/md";




const titles = [
  "Date of Commencement",
  "Date of Completion",
   "GST Certificate",
  "PO Copy Number",
  "EPFO Allotment Copy",
  "ESIC Allotment Copy",
  "P Tax RC Number",
  "PT EC Number",
  "LWF Number",
  "Factory Licence",
  "Building Plan Layout",
  "Stability Certificate",
  "Consent to Establishment",
  "Consent to Operations",
  "Fire Advisory",
  "Fire NOC",
  "Environment Clearance",
  "Medical/Hospital - Certificate",
  "Apprenticeship Registration",
  "NEEM/NAPS - Registration",
  "CLRA RC",
  "S&CE RC",
  "CLRA Licence",
  "BOCW RC",
  "ISMW RC",
  "ISMW Licence",
  "PSARA Licence",
  "FSSAI Licence",
  "WC Policy Number",
  "HR Policy Undertaking Ack",
  

];





const MasterData = () => {

  const initialState = titles.map(title => ({ value: '', fileUrl: '',validDate:'',noOfWorkers:'', validation: 0, remark: '',vendorRemark: '', na: false, qId: '', editing: false, isFileModified: false }));
  const [cardStates, setCardStates] = useState(initialState);
  const fileInputRefs = useRef(Array(titles.length).fill(null).map(() => React.createRef()));
  const [userId, setUserId] = useState('');
  const [userType, setUserType] = useState('');
  const[loading,setLoading] = useState(true)
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
  const [countValidation1, setCountValidation1] = useState(0);
  const [countValidation2, setCountValidation2] = useState(0);
  const [countValidation3, setCountValidation3] = useState(0);
  const [snackbarErrorMessage, setSnackbarErrorMessage] = useState('');
  const [uploadStatus, setUploadStatus] = useState(Array(titles.length).fill('upload'));
  const [initialCardStates, setInitialCardStates] = useState(initialState);







  useEffect(() => {
    const userData = JSON.parse(sessionStorage.getItem('user'));

    if (userData && userData.id) {
      setUserId(userData.id);
      setUserType(userData.type);

    }
  }, []);

  useEffect(() => {
   
    if (userType === 'vendor') {
      fetchData(userId);
    }
 
  

  }, [userId]);




  const fetchData = async (userId) => {
    try {
      const response = await api.masterData.getVendorMasterData(userId);
      const fieldNames= [
        "dateOfCommencement",
        "dateOfCompletion",
        "GSTCertificate",
        "poCopy",
        "epfoAllotment",
        "esicAllotment",
        "pTaxRc",
        "ptEc",
        "lwf",
        "factoryLicence",
        "buildingPlanLayout",
        "stabilityCertificate",
        "concernToEstablishment",
        "concernToOperations",
        "fireAdvisory",
        "fireNoc",
        "environmentClearance",
        "medicalOrHospitalCertificate",
        "apprenticeshipRegistration",
        "neemOrNapsRegistration",
        "clraRc",
        "sAndCeRc",
        "clraLicence",
        "bocwRc",
        "ismwRc",
        "ismwLicence",
        "passaraLicence",
        "fssaiLicence",
        "wCPolicyNumber",
        "hrPolicyUndertakingAck",
        
      
      ];
      if (response.status === 200) {
        const responseData = response.data.data;
        let validation1 = 0;
        let validation2 = 0;
        let validation3 = 0;

        const updatedCardStates = fieldNames.map(fieldName => {
          const fieldData = responseData[fieldName] || {};
         
          let background = COLORS.light;
  
          const validation = fieldData.validation;
  
          if (validation === 1) {
            background = COLORS.bggray;
            validation1 += 1;
          } else if (validation === 2) {
            background = COLORS.success;
            validation2 += 1;
          } else if (validation === 3) {
            background = COLORS.danger;
            validation3 += 1;
          }
  
          const fileUrl = fieldData.fileUrl;
          const fileName = fileUrl ? fileUrl.substring(fileUrl.lastIndexOf('/') + 1) : '';
          return {
            key: fieldNames, // Keep track of the field name
          value: fieldData.value || '',
          fileUrl: fieldData.fileUrl || '',
          fileName: fileName,
          validation: fieldData.validation || 0,
          validDate: fieldData.validDate || '',
          noOfWorkers: fieldData.noOfWorkers || '',
          remark: fieldData.remark || '',
          vendorRemark: fieldData.vendorRemark || '',
          na: fieldData.na || false,
          editing: fieldData.editing || false,
          qId: fieldData.qId || '',
          background: background,
           
          };
        });
        const updatedUploadStatus = updatedCardStates.map(card => 
          card.fileUrl ? 'uploaded' : 'upload'
        );

        setCardStates(updatedCardStates);
        setUploadStatus(updatedUploadStatus);
        setInitialCardStates(updatedCardStates);
        setCountValidation1(validation1);
        setCountValidation2(validation2);
        setCountValidation3(validation3);
        setLoading(false)
        
        
       
      } else if (response.status === 404) {
        setSnackbarOpen(true);
        setSnackbarErrorMessage("MasterData not found for this vendor");
        setCardStates(initialState);
        setLoading(false)
      }
      else if (response.status === 500) {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message);
        setCardStates(initialState);
        setLoading(false)
      }
      else if (response.status === 400) {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message);
        setCardStates(initialState);
        setLoading(false)
      }
      else {
        setSnackbarOpen(true);
        setSnackbarErrorMessage("Error fetching details");
        setCardStates(initialState);
        setLoading(false)
      }


    } catch (error) {
      console.error('Error fetching vendor data:', error);
    }
  };

 


  const handleFileChange = (e, index) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const updatedCardStates = [...cardStates];
      updatedCardStates[index].fileUrl = '';
      updatedCardStates[index].fileName = selectedFile.name;
      updatedCardStates[index].vendorRemark = ''
      updatedCardStates[index].isFileModified = false;
      setCardStates(updatedCardStates);
      const updatedUploadStatus = [...uploadStatus];
      updatedUploadStatus[index] = 'upload';
      
      setUploadStatus(updatedUploadStatus);
    }
  };
  const handleFileUpload = async (index, title) => {
    const selectedFile = fileInputRefs.current[index].current.files[0];
    
    if (!selectedFile) {
   
      setErrorSnackbarOpen(true);
      setSnackbarErrorMessage('No file selected!');
      
      return;
    }

    const formData = new FormData();
    formData.append('file', selectedFile);
    formData.append('vendorId', userId);
    formData.append('fieldName', title);

    const updatedUploadStatus = [...uploadStatus];
    updatedUploadStatus[index] = 'uploading';
    setUploadStatus(updatedUploadStatus);
    try {
      const response = await axios.put('https://www.grcpulse.in/api/companyMasterData/uploadfile', formData)
     if(response.status === 200){
      const updatedCardStates = [...cardStates];
      updatedCardStates[index].fileUrl = response.data.data;
      updatedCardStates[index].fileName = selectedFile.name;
      setCardStates(updatedCardStates);
      updatedUploadStatus[index] = 'uploaded';
      updatedCardStates[index].isFileModified = true;
      setUploadStatus(updatedUploadStatus);
      setSnackbarOpen(true);
      setSnackbarMessage('File uploaded successfully!');
     
    } 
    else if(response.status === 413){
      setErrorSnackbarOpen(true);
      setSnackbarErrorMessage("File size should be below 6MB");
      updatedUploadStatus[index] = 'upload';
      const updatedCardStates = [...cardStates];
      updatedCardStates[index].fileUrl = '';
      updatedCardStates[index].fileName = '';
      updatedCardStates[index].isFileModified = false;
      setCardStates(updatedCardStates);
      setUploadStatus(updatedUploadStatus);
    }
    else if(response.status === 404){
      setErrorSnackbarOpen(true);
      setSnackbarErrorMessage(response.data.message);
      updatedUploadStatus[index] = 'upload';
      const updatedCardStates = [...cardStates];
      updatedCardStates[index].fileUrl = '';
      updatedCardStates[index].fileName = '';
      updatedCardStates[index].isFileModified = false;
      setCardStates(updatedCardStates);
      setUploadStatus(updatedUploadStatus);
    }
    else if(response.status === 500){
      setErrorSnackbarOpen(true);
      setSnackbarErrorMessage(response.data.message);
      updatedUploadStatus[index] = 'upload';
      const updatedCardStates = [...cardStates];
      updatedCardStates[index].fileUrl = '';
      updatedCardStates[index].fileName = '';
      updatedCardStates[index].isFileModified = false;
      setCardStates(updatedCardStates);
      setUploadStatus(updatedUploadStatus);
    }
  }catch (error) {

      console.error('Error uploading file:', error);
      
      updatedUploadStatus[index] = 'upload';
      setUploadStatus(updatedUploadStatus);
    }

  };

  const handleUploadClick = (index) => {
    fileInputRefs.current[index].current.click();
  };

  const handleInputChange = (e, index) => {
    const { value } = e.target;
    const updatedCardStates = [...cardStates];
    updatedCardStates[index].value = value;
    updatedCardStates[index].vendorRemark = ''
   
    setCardStates(updatedCardStates);
  };
  const handleRemarkChange = (e,index) => {
    const {value} = e.target;
    const updatedCardStates = [...cardStates];
    updatedCardStates[index].vendorRemark = value;
    setCardStates(updatedCardStates);

   
};
  const handleEditClick = (index) => {
    const updatedCardStates = [...cardStates];
    setInitialCardStates(prevStates => {
      const newStates = [...prevStates];
      newStates[index] = { ...cardStates[index] };
      return newStates;
    });
    updatedCardStates[index].editing = true;
    setCardStates(updatedCardStates);
  };

  const handleNotApplicableChange = (index) => {
    const updatedCardStates = [...cardStates];
    updatedCardStates[index].na = !updatedCardStates[index].na;
   

    if (updatedCardStates[index].na) {
     
    
      updatedCardStates[index].value = '';
      updatedCardStates[index].fileUrl = '';
      updatedCardStates[index].fileName = '';
      updatedCardStates[index].noOfWorkers = '';
      updatedCardStates[index].validDate = '';
      updatedCardStates[index].vendorRemark = ''
      const inputRef = fileInputRefs.current[index];
      if (inputRef && inputRef.current) {
        inputRef.current.value = ''; 
      }

      const updatedUploadStatus = [...uploadStatus];
      updatedUploadStatus[index] = 'upload';
      setUploadStatus(updatedUploadStatus);
   
  
      
    

    }
   
    setCardStates(updatedCardStates);
  
  };
  const handleValidDateChange = (value, index) => {
  // Allow clearing the input
  if (value === '') {
    const updatedCardStates = [...cardStates];
    updatedCardStates[index].validDate = '';
    updatedCardStates[index].vendorRemark = '';
    setCardStates(updatedCardStates);
    return;
  }

  // Continue with date format validation
  const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
  if (!dateRegex.test(value)) {
    return;
  }

  const date = new Date(value);
  if (isNaN(date.getTime())) {
    return;
  }

  const updatedCardStates = [...cardStates];
  updatedCardStates[index].validDate = value;
  updatedCardStates[index].vendorRemark = '';
  setCardStates(updatedCardStates);
};

  const handleNumOfWorkersChange = (value, index) => {
    if(value>=0){
    const updatedCardStates = [...cardStates];
    updatedCardStates[index].noOfWorkers = value;
    updatedCardStates[index].vendorRemark = ''
    setCardStates(updatedCardStates);
    }
    else{
      setErrorSnackbarOpen(true);
      setSnackbarErrorMessage('Please enter valid number');
      const updatedCardStates = [...cardStates];
    updatedCardStates[index].noOfWorkers = '';
    
    setCardStates(updatedCardStates);
    }
  };
  const handleDateChange = (value, index) => {
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;

  if (!dateRegex.test(value)) {
    return; // Don't update state if format is invalid
  }

  // Additional check: Is it a real date?
  const date = new Date(value);
  if (isNaN(date.getTime())) {
    // alert("Invalid date value");
    return;
  }
    const updatedCardStates = [...cardStates];
    updatedCardStates[index].value = value;
    updatedCardStates[index].vendorRemark = ''
    setCardStates(updatedCardStates);
  };

  const handlesave = async (index) => {
    const updatedCardStates = [...cardStates];
    const currentCardState = updatedCardStates[index];

if (currentCardState.fileName && uploadStatus[index] !== 'uploaded') {
  
  alert('Please upload the file before proceeding further.');

setTimeout(()=>{
  const userConfirmed = window.confirm('Do you want to upload the file now?');
  if (userConfirmed) {
    handleFileUpload(index,currentCardState.fileName);  
  } else {
    updatedCardStates[index].fileName = '';
    updatedCardStates[index].fileUrl = '';
    updatedCardStates[index].editing = false;

    const current = updatedCardStates[index];
    const initial = initialCardStates[index];


    const otherFieldsModified =
      current.value !== initial.value ||
      current.validDate !== initial.validDate ||
      current.noOfWorkers !== initial.noOfWorkers ||
      current.vendorRemark !== initial.vendorRemark ||
      current.na !== initial.na;

    if (!otherFieldsModified) {
      setErrorSnackbarOpen(true);
      setSnackbarErrorMessage("No changes detected. Please modify the fields before saving.");
      return;
    }

    setCardStates(updatedCardStates);
    setSnackbarOpen(true);
    setSnackbarMessage('Saving without uploading file');
    setTimeout(()=>{
    handlesave(index)  
    },3000)
  }
},1000)
return;
}

    const updatedValue = cardStates[index].value;
    const updatedValidation = 1;
    const updatedValidDate = cardStates[index].validDate;
    const updatedRemark = cardStates[index].remark;
    const updatedNoOfWorkers = cardStates[index].noOfWorkers;
    const updatedVendorRemark = cardStates[index].vendorRemark
    const updatena = cardStates[index].na;
    const updatedFileUrl = cardStates[index].fileUrl;
    const updatedFileUpload = cardStates[index].isFileModified;

   
  const currentValues = updatedCardStates[index];
 
  
  const initialValues = initialCardStates[index];

  

  const isModified =
  currentValues.value !== initialValues.value ||
  (updatedFileUpload && currentValues.fileUrl !== initialValues.fileUrl) ||
  currentValues.validDate !== initialValues.validDate ||
  currentValues.noOfWorkers !== initialValues.noOfWorkers ||
  currentValues.vendorRemark !== initialValues.vendorRemark ||
  currentValues.na !== initialValues.na;

if (!isModified) {
  updatedCardStates[index] = { ...initialValues, editing: true };

  if (uploadStatus[index] != 'uploaded') {
    updatedCardStates[index].fileName = '';  
    updatedCardStates[index].fileUrl = '';   
  } else {
    updatedCardStates[index].fileName = initialValues.fileName || ''; 
    updatedCardStates[index].fileUrl = initialValues.fileUrl || '';   
  }

  const updatedUploadStatus = [...uploadStatus];
  updatedUploadStatus[index] = initialValues.fileUrl ? 'uploaded' : ''; 

  setCardStates(updatedCardStates);
  setUploadStatus(updatedUploadStatus);
  setErrorSnackbarOpen(true);
  setSnackbarErrorMessage("No changes detected. Please modify the fields before saving.");
  return;
}
if (uploadStatus[index] != 'uploaded') {

  if (initialValues.fileUrl) {
    updatedCardStates[index].fileUrl = initialValues.fileUrl || ''; // Use previous fileUrl if file was uploaded before
    updatedCardStates[index].fileName = initialValues.fileName || '';
   
  } else {
    updatedCardStates[index].fileName = '';  // Clear file name if no previous file exists
    updatedCardStates[index].fileUrl = '';   // Clear file URL if no previous file exists
  }
}
if (uploadStatus[index] === 'upload') {
  updatedCardStates[index].fileName = '';
  updatedCardStates[index].fileUrl = ''; 
}
if (uploadStatus[index] === 'uploaded') {
  updatedCardStates[index].fileName = updatedFileUrl ? updatedFileUrl.substring(updatedFileUrl.lastIndexOf('/') + 1) : '';  // Show file name
  updatedCardStates[index].fileUrl = updatedFileUrl; 
}
const updatedUploadStatus = [...uploadStatus];
setCardStates(updatedCardStates);
setUploadStatus(updatedUploadStatus);

 
   
const fieldNames= [
  "dateOfCommencement",
  "dateOfCompletion",
  "GSTCertificate",
  "poCopy",
  "epfoAllotment",
  "esicAllotment",
  "pTaxRc",
  "ptEc",
  "lwf",
  "factoryLicence",
  "buildingPlanLayout",
  "stabilityCertificate",
  "concernToEstablishment",
  "concernToOperations",
  "fireAdvisory",
  "fireNoc",
  "environmentClearance",
  "medicalOrHospitalCertificate",
  "apprenticeshipRegistration",
  "neemOrNapsRegistration",
  "clraRc",
  "sAndCeRc",
  "clraLicence",
  "bocwRc",
  "ismwRc",
  "ismwLicence",
  "passaraLicence",
  "fssaiLicence",
  "wCPolicyNumber",
  "hrPolicyUndertakingAck",
  

];
const fieldName = fieldNames[index];
    const masterdata = {
      vendorId: userId,
      [fieldName]: {
        value: updatedValue,
        fileUrl: updatedFileUrl,
        validation: updatedValidation,
        remark: updatedRemark,
        vendorRemark: updatedVendorRemark,
        na: updatena,
        validDate: updatedValidDate,
        noOfWorkers: updatedNoOfWorkers, 
      }
    };
       
    try {
      const response = await api.masterData.updateMasterData(masterdata)
      if (response.status === 200) {
        for (const key in masterdata) {

          if (masterdata.hasOwnProperty(key)) {

            const updatedCardStates = [...cardStates];
            updatedCardStates[index].editing = false;
            updatedCardStates[index].background = COLORS.bggray;
            updatedCardStates[index].validation = 1;
            setCardStates(updatedCardStates);
            

          }
        }
        setSnackbarOpen(true);
        setSnackbarMessage('Saved Successfully');
         try {
       
              // console.log('Calling assessorToMail with payload:', payload);
              const response = await api.vendor.mailToAssessorFromVendorMasterData({vendorId: userId});
      
              if (response.status === 200) {
                setTimeout(()=>{

                
                setSnackbarOpen(true);
                setSnackbarMessage(response.data.message);
                },2000)
              }
              else if(response.status === 400){
                setTimeout(()=>{
                setErrorSnackbarOpen(true);
                setSnackbarErrorMessage(response.data.message);
                },2000)
              }
              
               else if(response.status === 500){
                setTimeout(()=>{
                setErrorSnackbarOpen(true);
                setSnackbarErrorMessage(response.data.message);
                },2000)
              } else {
                setErrorSnackbarOpen(true);
                setSnackbarErrorMessage(response.data.message);
              }
            } catch (emailErr) {
              console.error('assessorToMail error:', emailErr);
              setErrorSnackbarOpen(true);
              setSnackbarErrorMessage(emailErr?.response?.data?.message);
            }
      }
     
      else if (response.status === 400) {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage('Data not updated, Please try again');

      }
      else if (response.status === 404) {
           setErrorSnackbarOpen(true);
        setSnackbarErrorMessage('There is no masterdata available assosiated with this Id');
      }
      else {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage('Error in Updating the data,please try again');
      }
    }
    catch (error) {
      console.error("Error updating masterdata:", error);
    }
  };


  


  const handleCancelButton = (index) => {
    const updatedCardStates = [...cardStates];
    updatedCardStates[index] = initialCardStates[index];
    updatedCardStates[index].editing = false;
    const updatedUploadStatus = [...uploadStatus];
    const initialValues = initialCardStates[index];
    updatedUploadStatus[index] = initialValues.fileUrl ? 'uploaded' : 'upload'; 
   
setCardStates(updatedCardStates);
setUploadStatus(updatedUploadStatus);
  };



  const chunkArray = (array, chunkSize) => {
    const chunkedArray = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      chunkedArray.push(array.slice(i, i + chunkSize));
    }
    return chunkedArray;
  };

  


  const chunkedTitles = chunkArray(titles, 3);
  const renderInput = (index) => {
    // Handle the case for indices that need a 'validDate' and 'numOfWorkers'
    if (index === 3 || index === 9 || index === 11 || index === 16 || index === 25 || index === 22 || index === 23 ||  index === 28 || index === 26 ||  index === 27 ) {
      return (
        <>
         
          
            <input
              type="text"
              id="value"
              placeholder={`Enter ${titles[index]}`}
              className="p-2 mb-2"
              style={{ width: '100%', border: '1px solid #eee', borderRadius: '5px' }}
              value={cardStates[index].value}
              onChange={(e) => handleInputChange(e, index)}
              disabled={cardStates[index].na}
            />
        
  
          {index === 22 || index === 23 ||  index === 28 ? (
          
            <section className="d-flex justify-content-between">
             
              
                <input
                  type="date"
                  id="validDate"
                  placeholder='Valid Date'
                  className="p-2 mb-2"
                  style={{ width: '100%', border: '1px solid lightgray', borderRadius: '5px' }}
                  value={cardStates[index].validDate}
                  onChange={(e) => handleValidDateChange(e.target.value, index)}
                  disabled={cardStates[index].na}
                />
            
                <input
                  type="number"
                  id="numOfWorkers"
                  placeholder="No Of Workers"
                  className="p-2 mb-2"
                  style={{ width: '100%', border: '1px solid lightgray', borderRadius: '5px' }}
                  value={cardStates[index].noOfWorkers}
                  onChange={(e) => handleNumOfWorkersChange(e.target.value, index)}
                  disabled={cardStates[index].na}
                  min="0"
                />
            
            </section>
          ) : (
       
         
              <input
                type="date"
                id="validDate"
                placeholder='Valid Date'
                className="p-2 mb-2"
                style={{ width: '100%', border: '1px solid lightgray', borderRadius: '5px' }}
                value={cardStates[index].validDate}
                onChange={(e) => handleValidDateChange(e.target.value, index)}
                disabled={cardStates[index].na}
              />
           
          )}
        </>
      );
    } else {
      // Handle the case for indices 0 and 1 where 'value' should be replaced with 'date'
      if (index === 0 || index === 1) {
        return (
          <div className="mb-1">
        
            <input
              type="date"
              id="value"
              className="p-2 mb-1"
              style={{ width: '100%', border: '1px solid lightgray', borderRadius: '5px' }}
              value={cardStates[index].value}
              onChange={(e) => handleDateChange(e.target.value, index)}
              disabled={cardStates[index].na}
            />
          </div>
        );
      } else {
        // For other indices, always display the 'value' field as a text input
        return (
          <div className="mb-1">
          
            <input
              type="text"
              placeholder={`Enter ${titles[index]}`}
              id="value"
              className="p-2"
              style={{ width: '100%', border: '1px solid lightgray', borderRadius: '5px' }}
              value={cardStates[index].value}
              onChange={(e) => handleInputChange(e, index)}
              disabled={cardStates[index].na}
            />
          </div>
        );
      }
    }
  };
  


  return (
    <>
    {loading ? (
      <div className="d-flex flex-row align-items-center justify-content-center" style={{ marginTop: '80px' }}>
      <h3>Loading</h3>
<div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div> 
<div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div>
<div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div>

</div>
       ) : (
   <div style={{ overflow: 'hidden' }}>

      <div className="mt-4 mb-3 d-md-flex " style={{ justifyContent: 'space-between' }} >

        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          severity="success"
          open={snackbarOpen}
          autoHideDuration={2000}
          onClose={() => setSnackbarOpen(false)}
           sx={{
            marginTop: '2.9%', 
            marginRight: '7%'
          }}
        >
          <SnackbarContent style={{ backgroundColor: "green" }} message={snackbarMessage} />
        </Snackbar>
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          severity="success"
          open={errorSnackbarOpen}
          autoHideDuration={2000}
          onClose={() => {setErrorSnackbarOpen(false)}}
          sx={{
            marginTop: '2.9%', 
            marginRight: '7%'
          }}
        >
          <SnackbarContent style={{ backgroundColor: "red" }} message={snackbarErrorMessage} />
        </Snackbar>

        <div style={{ letterSpacing: '1px' }}>
          <div style={{ backgroundColor: COLORS.bggray, width: '15px', height: '15px', display: 'inline-block', marginRight: '4px', marginLeft: '8px', borderRadius: '50%' }}></div>
          <span style={{ fontSize: '14px' }}>Under review : {countValidation1}</span>
          <div className="vr  mx-3"></div>
          <div style={{ backgroundColor: COLORS.success, width: '15px', height: '15px', display: 'inline-block', marginRight: '4px', borderRadius: '50%' }}></div>
          <span style={{ fontSize: '14px' }}>Accepted : {countValidation2}</span>
          <div className="vr mx-3"></div>
          <div style={{ backgroundColor: COLORS.danger, width: '15px', height: '15px', display: 'inline-block', marginRight: '4px', borderRadius: '50%' }}></div>
          <span style={{ fontSize: '14px' }}>Rejected : {countValidation3}</span>
        </div>

      </div>

      <div style={{ minHeight:'420px',maxHeight: "400px",overflowY: "auto" }} >
      <table>
  <thead className="position-sticky top-0 text-center table-dark" style={{ zIndex: 10 }}>
    <tr className='text-white bg-dark'>
      <th>Name of DOC</th>
      <th>Vendor Input</th>
{/*      
      <th>Vendor Remarks</th> */}
       <th>Actions</th>
      <th>Uploaded file</th>
      <th>Status</th>
      <th>Assessor Remarks</th>
    </tr>
  </thead>
  <tbody >
    {chunkedTitles.flat().map((title, index) => {
      const state = cardStates[index];
      const fileName = state.fileUrl?.substring(state.fileUrl.lastIndexOf('/') + 1) || '';
      const validationText = state.validation === 1 ? "Under Review" : state.validation === 2 ? "Accepted" : state.validation === 3 ? "Rejected" : "Not Uploaded";

      return (
        <tr key={index} style={{backgroundColor:cardStates[index].background}}>
          {/* First Column: Name */}
          <td>{title}</td>

          {/* Second Column: Input Fields */}
          <td style={{ minWidth: "300px" }}>
            {state.editing ?(
              <>
                <Form.Check
                className='d-flex gap-2 float-end'
                  label="Not Applicable"
                  checked={state.na}
                  onChange={() => handleNotApplicableChange(index)}
                />
                {renderInput(index)}
                <Form.Control
                  type="text"
                  placeholder={`Upload proof for ${title}`}
                  value={state.fileName || ''}
                  readOnly
                  disabled={state.na}
                  className="my-1"
                />
                <div className="d-flex mb-2 mt-2 float-end gap-2">
                  <button className="btn btn-sm btn-outline-primary" disabled={state.na}>
                    <BiUpload onClick={() => handleUploadClick(index)} />
                  </button>
                  <Button
                    variant="light"
                    style={{ border: '1px solid gray' }}
                    disabled={state.na || uploadStatus[index] === 'uploading' || uploadStatus[index] === 'uploaded'}
                    onClick={() => handleFileUpload(index, title)}
                  >
                    {uploadStatus[index] === 'uploading' ? 'Uploading...' :
                      uploadStatus[index] === 'uploaded' ? 'Uploaded' : 'Upload'}
                  </Button>
                </div>
                <input
                  type="file"
                  style={{ display: 'none' }}
                  onChange={(e) => handleFileChange(e, index)}
                  ref={fileInputRefs.current[index]}
                />
                <Form.Control
                  as="textarea"
                  placeholder="Enter your remarks here"
                  rows={2}
                  className="mt-3"
                  value={state.vendorRemark}
                  onChange={(e) => handleRemarkChange(e, index)}
                />
              </>
             ) : (
              <div>
  {(state.value || state.validDate || state.noOfWorkers || state.vendorRemark || (state.na && !state.value && !state.fileUrl)) && (
    <div
      style={{
        maxHeight: '150px',
        width: '320px',
       overflowY:'auto',
       display:'grid',
        alignItems: 'center',
        justifyContent: 'center',

        position: 'relative'
      }}
    >
     <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', maxWidth: '250px' }}>
  {state.value && (
    <div style={{ wordWrap: 'break-word' }}>
      <strong>Value:</strong> <span>{state.value}</span>
    </div>
  )}
  
  {state.validDate && (
    <div>
      <strong>Valid Date:</strong>{' '}
      {state.validDate.slice(0, 10).split('-').reverse().join('-')}
    </div>
  )}
  
  {state.noOfWorkers && (
    <div>
      <strong>No of Workers:</strong> <span>{state.noOfWorkers}</span>
    </div>
  )}

  {state.na && !state.value && !state.fileUrl && (
    <div>
      <strong>Status:</strong> Not Applicable
    </div>
  )}

  {state.vendorRemark && (
    <div
      style={{
        border: '1px solid #ccc',
        borderRadius: '4px',
        padding: '6px',
        backgroundColor: '#f9f9f9',
        minHeight: '60px',
        maxHeight: '120px',
        overflowY: 'auto',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
      }}
    >
      <strong>Remark:</strong>
      <div>{state.vendorRemark}</div>
    </div>
  )}
</div>

    </div>
  )}
</div>
            )}



            
          </td>
          
         
          {/* <td>
 <Form.Control
                  as="textarea"
                  placeholder="Enter your remarks here"
                  rows={2}
                  className="mt-2"
                  value={state.vendorRemark}
                  onChange={(e) => handleRemarkChange(e, index)}
                />
                </td> */}
                  <td className="text-center">
            {state.editing ? (
              <div className="d-flex flex-column gap-2">
                <button className='btn btn-sm btn-outline-secondary' onClick={() => handleCancelButton(index)}>Cancel</button>
                <button
                 className='btn btn-sm btn-dark'
                  onClick={() => handlesave(index)}
                  disabled={
                    !(state.value || state.fileUrl || state.na || state.validDate || state.noOfWorkers)
                  }
                >
                  Save
                </button>
              </div>
            ) : (
              
              <button className='btn btn-sm btn-outline-danger' onClick={() => handleEditClick(index)}>
                       <span>Upload/Edit</span>

              </button>
            )}
          </td>
          {/* Third Column: Buttons */}
         <td>
            {fileName && (
                  <div className="flex justify-content-center gap-3">
    
                    <button className="flex flex-col items-center text-sm text-green-700" onClick={() => window.open(`https://docs.google.com/gview?url=${state.fileUrl}&embedded=true`, '_blank')}>
                      <MdFileOpen className="text-xl text-success" /> View
                    </button>
                   
                    <a download className='flex flex-col items-center text-sm text-blue-700' href = {state.fileUrl}>
                      <FaFileDownload className="text-xl text-primary" /> Download
                    </a>
                  </div>
                )}
          </td>
<td>
    <p> {validationText}</p>
  </td>
          {/* Fourth Column: Assessor Feedback */}
          <td>
            {state.remark && (
<div
      style={{
        border: '1px solid #ccc',
        borderRadius: '4px',
        padding: '6px',
        backgroundColor: '#f9f9f9',
        minHeight: '60px',
        maxHeight: '120px',
        overflowY: 'auto',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
      }}>
                {state.remark}
              </div>
            )}
          
          </td>

        </tr>
      );
    })}
  </tbody>
</table>
      </div>
    </div>
      )}
      </>
  );
};

export default MasterData;
